angular.module('unica_event_tag.event_tag_services')

.factory('EventTagListService', function ($http, getBaseApiURL) {

	var eventTagListService = {};

	eventTagListService.list = function (eventId, limit, offset) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event-tag/list/' + eventId,
			data: {
				limit: limit,
				offset: offset,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.eventTags;
			}

		});

	};

	eventTagListService.get = function (eventTagId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event-tag/detail/' + eventTagId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.eventTag;
			}

		});

	};

	eventTagListService.listByInvitation = function ( eventTagId, invitationId ) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-tag/list/' + invitationId,
			data: {
				event_id: eventTagId,
				invitation_id: invitationId
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.eventTags;
			}

		});

	};


	return eventTagListService;
});